import React, { Component } from "react";
import { Container } from "react-bootstrap";

class Footer extends Component {
  render() {
    return (
      <footer className="footer px-0 px-lg-3">
        <Container fluid>
          <nav>
            <p className="copyright text-center">
              This product is made by <a href="http://sealion.live">Sea Lion</a>
            </p>
          </nav>
        </Container>
      </footer>
    );
  }
}

export default Footer;
